import { Box } from '@chakra-ui/react';
import type { FC } from 'react';

import ArrowRight from '@/components/Icon/ArrowRight';
import { Link } from '@/components/Navigation/Link';
import { colors } from '@/styles/theme/constants';

import type { ButtonBackProps } from './types';

const ButtonBack: FC<ButtonBackProps> = ({ url, ...boxProps }) => {
  return (
    <Box {...boxProps} data-testid="buttonBack">
      <Link
        href={url}
        padding="8px"
        borderRadius="8px"
        border={`1px solid ${colors.red03}`}
        boxShadow="8px 8px 16px 0px rgba(255, 255, 255, 0.16)"
        width="fit-content"
        display="flex"
        alignItems="center"
        mb="40px"
        _hover={{
          textDecor: 'none',
        }}
      >
        <Box transform="rotate(180deg)">
          <ArrowRight width={18} height={18} fill={colors.red03} />
        </Box>
      </Link>
    </Box>
  );
};

export default ButtonBack;
